import { useContext } from 'react';
import { BannerFpContext } from '../../../../Contexts/BannerFpContext';
import { Grid } from '@mui/material';
import InputConfig from '../../../../Components/InputConfig';
import DropDownSingle from '../../../../Components/DropDownSingle';
import DropDownMultiple from '../../../../Components/DropDownMultiple';
import SwitchInput from '../../../../Components/SwitchInput';
import ConfirmBeforeTypeSwitchModal from '../ConfirmBeforeTypeSwitchModal';
import {
	CONFIG_STRUCTURE_KEYS,
	ALL_ENGINE_MODELS,
	ENGINE_MODEL_KEYS_CONDITIONS,
	FLOOR_PRICING_MODELS,
	DIMENSION_RULES_LIST
} from '../../constants';
import { Box } from '@mui/system';
import { Modalv2Context } from '../../../../Contexts/Modalv2Context';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import useCommonStyles from '../../../../commonStyles';
import { checkMandatoryFpSplitConfigKey } from '../../helpers';

const {
	FLOOR_PRICING_CONFIG,
	FLOOR_ENGINE_TYPE_SPLIT,
	ENGINE_TYPE,
	TRAFFIC_SPLIT,
	INCREMENT_DECREMENT_ACTIVE,
	HB_WON_FLOOR_ACTIVE,
	DEFAULT_FLOOR_VALUE,
	DIMENSION_RULES,
	USE_BASE_MULTIPLIER,
	USE_DIMENSION_MULTIPLIER,
	USE_BANNER_DRSD_MULTIPLIER,
	USE_HOURLY_BANNER_MULTIPLIER,
	DEFAULT_MULTIPLIER_VALUE,
	FLOOR_PRICING_MODEL,
	CLUSTERING_RULES_ENABLED
} = CONFIG_STRUCTURE_KEYS;

const BannerFpEngineModelCard = ({ bannerFpModel, deleteBannerFpModel, index }) => {
	const { bannerFpConfig, updateBannerFpConfig } = useContext(BannerFpContext);
	const { updateModalContent } = useContext(Modalv2Context);
	const commonStyleClasses = useCommonStyles();
	const removeKeysAndUpdateBannerFpModel = (engineType) => {
		const clonedBannerFpConfig = structuredClone(bannerFpConfig);
		const clonedBannerFpModel =
			clonedBannerFpConfig[FLOOR_PRICING_CONFIG][FLOOR_ENGINE_TYPE_SPLIT][index];
		const bannerFpEngineKeys = Object.keys(ENGINE_MODEL_KEYS_CONDITIONS);
		bannerFpEngineKeys.forEach((key) => {
			const engineTypesAllowed = ENGINE_MODEL_KEYS_CONDITIONS[key];
			if (!engineTypesAllowed.includes(engineType)) {
				delete clonedBannerFpModel[key];
			}
		});
		updateBannerFpEngineModel(ENGINE_TYPE, engineType, clonedBannerFpConfig);
	};

	const updateBannerFpEngineModel = (key, updatedValue) => {
		const clonedBannerFpConfig = structuredClone(bannerFpConfig);
		const clonedBannerFpModel =
			clonedBannerFpConfig[FLOOR_PRICING_CONFIG][FLOOR_ENGINE_TYPE_SPLIT][index];
		clonedBannerFpModel[key] = updatedValue;
		updateBannerFpConfig(clonedBannerFpConfig);
	};

	const switchEngineType = (newEngineType) => {
		updateModalContent(
			<ConfirmBeforeTypeSwitchModal
				cbOnApproval={() => {
					removeKeysAndUpdateBannerFpModel(newEngineType);
					updateModalContent(null);
				}}
				noteContent="Note**: Switching between Engine types will cause parameters to be deleted that are not required
				in the new Engine type. Are you sure you want to switch ?
"
			/>
		);
	};

	return (
		<Grid item xs={12}>
			<Box
				style={{
					border: '1px solid rgba(0, 0, 0, 0.38)',
					padding: '2rem',
					marginLeft: '3rem',
					borderRadius: '4px'
				}}
			>
				<Grid container spacing={1}>
					<Grid item xs={3}>
						<DropDownSingle
							isObjectEditor={false}
							directValue={bannerFpModel[ENGINE_TYPE]}
							updateDirectValue={switchEngineType}
							list={ALL_ENGINE_MODELS}
							label="Engine Type"
							isMandatory={true}
						/>
					</Grid>
					{ENGINE_MODEL_KEYS_CONDITIONS[FLOOR_PRICING_MODEL].includes(
						bannerFpModel[ENGINE_TYPE]
					) && (
						<Grid item xs={3}>
							<DropDownSingle
								isObjectEditor={false}
								directValue={bannerFpModel[FLOOR_PRICING_MODEL]}
								updateDirectValue={(newVal) =>
									updateBannerFpEngineModel(FLOOR_PRICING_MODEL, newVal)
								}
								list={FLOOR_PRICING_MODELS}
								label="Floor Pricing Model"
								isMandatory={checkMandatoryFpSplitConfigKey(
									bannerFpModel[ENGINE_TYPE],
									FLOOR_PRICING_MODEL
								)}
							/>
						</Grid>
					)}
					<Grid item xs={3}>
						<InputConfig
							isObjectEditor={false}
							directValue={bannerFpModel[TRAFFIC_SPLIT]}
							updateDirectValue={(newTrafficSplit) => {
								updateBannerFpEngineModel(TRAFFIC_SPLIT, newTrafficSplit);
							}}
							inputType="number"
							label="Traffic Split"
							isMandatory={true}
						/>
					</Grid>
					{ENGINE_MODEL_KEYS_CONDITIONS[DEFAULT_FLOOR_VALUE].includes(
						bannerFpModel[ENGINE_TYPE]
					) && (
						<Grid item xs={3}>
							<InputConfig
								isObjectEditor={false}
								directValue={bannerFpModel[DEFAULT_FLOOR_VALUE]}
								updateDirectValue={(newDefaultFloorValue) => {
									updateBannerFpEngineModel(DEFAULT_FLOOR_VALUE, newDefaultFloorValue);
								}}
								inputType="number"
								label="Default Floor"
								isMandatory={checkMandatoryFpSplitConfigKey(
									bannerFpModel[ENGINE_TYPE],
									DEFAULT_FLOOR_VALUE
								)}
							/>
						</Grid>
					)}
					{ENGINE_MODEL_KEYS_CONDITIONS[DEFAULT_MULTIPLIER_VALUE].includes(
						bannerFpModel[ENGINE_TYPE]
					) && (
						<Grid item xs={3}>
							<InputConfig
								isObjectEditor={false}
								directValue={bannerFpModel[DEFAULT_MULTIPLIER_VALUE]}
								updateDirectValue={(newVal) => {
									updateBannerFpEngineModel(DEFAULT_MULTIPLIER_VALUE, newVal);
								}}
								inputType="number"
								label="DefaultMultiplier"
								isMandatory={checkMandatoryFpSplitConfigKey(
									bannerFpModel[ENGINE_TYPE],
									DEFAULT_MULTIPLIER_VALUE
								)}
							/>
						</Grid>
					)}
					{ENGINE_MODEL_KEYS_CONDITIONS[INCREMENT_DECREMENT_ACTIVE].includes(
						bannerFpModel[ENGINE_TYPE]
					) && (
						<Grid item xs={3}>
							<SwitchInput
								isObjectEditor={false}
								directValue={bannerFpModel[INCREMENT_DECREMENT_ACTIVE]}
								updateDirectValue={(newVal) =>
									updateBannerFpEngineModel(INCREMENT_DECREMENT_ACTIVE, newVal)
								}
								containerStyles={{ marginTop: '5rem' }}
								label="Incr Decr"
								isMandatory={checkMandatoryFpSplitConfigKey(
									bannerFpModel[ENGINE_TYPE],
									INCREMENT_DECREMENT_ACTIVE
								)}
							/>
						</Grid>
					)}
					{ENGINE_MODEL_KEYS_CONDITIONS[HB_WON_FLOOR_ACTIVE].includes(
						bannerFpModel[ENGINE_TYPE]
					) && (
						<Grid item xs={3}>
							<SwitchInput
								isObjectEditor={false}
								directValue={bannerFpModel[HB_WON_FLOOR_ACTIVE]}
								updateDirectValue={(newVal) =>
									updateBannerFpEngineModel(HB_WON_FLOOR_ACTIVE, newVal)
								}
								containerStyles={{ marginTop: '5rem' }}
								label="HbWonFloor"
								isMandatory={checkMandatoryFpSplitConfigKey(
									bannerFpModel[ENGINE_TYPE],
									HB_WON_FLOOR_ACTIVE
								)}
							/>
						</Grid>
					)}
					{ENGINE_MODEL_KEYS_CONDITIONS[USE_BASE_MULTIPLIER].includes(
						bannerFpModel[ENGINE_TYPE]
					) && (
						<Grid item xs={3}>
							<SwitchInput
								isObjectEditor={false}
								directValue={bannerFpModel[USE_BASE_MULTIPLIER]}
								updateDirectValue={(newVal) =>
									updateBannerFpEngineModel(USE_BASE_MULTIPLIER, newVal)
								}
								containerStyles={{ marginTop: '5rem' }}
								label="BaseMultiplier"
								isMandatory={checkMandatoryFpSplitConfigKey(
									bannerFpModel[ENGINE_TYPE],
									USE_BASE_MULTIPLIER
								)}
							/>
						</Grid>
					)}
					{ENGINE_MODEL_KEYS_CONDITIONS[USE_DIMENSION_MULTIPLIER].includes(
						bannerFpModel[ENGINE_TYPE]
					) && (
						<Grid item xs={3}>
							<SwitchInput
								isObjectEditor={false}
								directValue={bannerFpModel[USE_DIMENSION_MULTIPLIER]}
								updateDirectValue={(newVal) =>
									updateBannerFpEngineModel(USE_DIMENSION_MULTIPLIER, newVal)
								}
								containerStyles={{ marginTop: '5rem' }}
								label="Dimension Multiplier"
								isMandatory={checkMandatoryFpSplitConfigKey(
									bannerFpModel[ENGINE_TYPE],
									USE_DIMENSION_MULTIPLIER
								)}
							/>
						</Grid>
					)}
					{ENGINE_MODEL_KEYS_CONDITIONS[USE_BANNER_DRSD_MULTIPLIER].includes(
						bannerFpModel[ENGINE_TYPE]
					) && (
						<Grid item xs={3}>
							<SwitchInput
								isObjectEditor={false}
								directValue={bannerFpModel[USE_BANNER_DRSD_MULTIPLIER]}
								updateDirectValue={(newVal) =>
									updateBannerFpEngineModel(USE_BANNER_DRSD_MULTIPLIER, newVal)
								}
								containerStyles={{ marginTop: '5rem' }}
								label="Banner DRSD Multiplier"
								isMandatory={checkMandatoryFpSplitConfigKey(
									bannerFpModel[ENGINE_TYPE],
									USE_BANNER_DRSD_MULTIPLIER
								)}
							/>
						</Grid>
					)}
					{ENGINE_MODEL_KEYS_CONDITIONS[USE_HOURLY_BANNER_MULTIPLIER].includes(
						bannerFpModel[ENGINE_TYPE]
					) && (
						<Grid item xs={3}>
							<SwitchInput
								isObjectEditor={false}
								directValue={bannerFpModel[USE_HOURLY_BANNER_MULTIPLIER]}
								updateDirectValue={(newVal) =>
									updateBannerFpEngineModel(USE_HOURLY_BANNER_MULTIPLIER, newVal)
								}
								containerStyles={{ marginTop: '5rem' }}
								label="Hourly Banner Multiplier"
								isMandatory={checkMandatoryFpSplitConfigKey(
									bannerFpModel[ENGINE_TYPE],
									USE_HOURLY_BANNER_MULTIPLIER
								)}
							/>
						</Grid>
					)}
					{ENGINE_MODEL_KEYS_CONDITIONS[DIMENSION_RULES].includes(bannerFpModel[ENGINE_TYPE]) && (
						<Grid item xs={3}>
							<DropDownMultiple
								isObjectEditor={false}
								directValue={bannerFpModel[DIMENSION_RULES]}
								updateDirectValue={(newVal) => updateBannerFpEngineModel(DIMENSION_RULES, newVal)}
								list={DIMENSION_RULES_LIST}
								label="Dimension Rules"
								isMandatory={checkMandatoryFpSplitConfigKey(
									bannerFpModel[ENGINE_TYPE],
									DIMENSION_RULES
								)}
							/>
						</Grid>
					)}
					{ENGINE_MODEL_KEYS_CONDITIONS[CLUSTERING_RULES_ENABLED].includes(
						bannerFpModel[ENGINE_TYPE]
					) && (
						<Grid item xs={3}>
							<SwitchInput
								isObjectEditor={false}
								directValue={bannerFpModel[CLUSTERING_RULES_ENABLED]}
								updateDirectValue={(newVal) =>
									updateBannerFpEngineModel(CLUSTERING_RULES_ENABLED, newVal)
								}
								containerStyles={{ marginTop: '5rem' }}
								isMandatory={checkMandatoryFpSplitConfigKey(
									bannerFpModel[ENGINE_TYPE],
									CLUSTERING_RULES_ENABLED
								)}
								label="Clustering Rules Enabled"
							/>
						</Grid>
					)}
					<Grid item xs={12}>
						<DeleteOutlinedIcon
							color="primary"
							onClick={() => deleteBannerFpModel(index)}
							className={commonStyleClasses.icon}
							style={{ marginTop: '2rem' }}
						/>
					</Grid>
				</Grid>
			</Box>
		</Grid>
	);
};

export default BannerFpEngineModelCard;
